import PropTypes from 'prop-types'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

import Toggle from '../../common/form/Toggle'
import { ReactComponent as GripDotsVertical } from '../../../assets/images/common/icons/grip-dots-vertical.svg'

import colors from '../../../assets/styles/globals.scss'
import classes from './ColumnManagementPopover.module.scss'

const SortableColumnItem = ({ column, isVisible, onToggle }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: column.field })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  }

  return (
    <div ref={setNodeRef} style={style} className={classes.columnItem}>
      <div className={classes.dragHandle} {...attributes} {...listeners}>
        <GripDotsVertical width={12} height={12} fill={colors.darkGray} />
      </div>
      <span className={classes.columnLabel}>{column.label}</span>
      <Toggle
        size='small'
        checked={isVisible}
        onChange={() => onToggle(column.field)}
      />
    </div>
  )
}

SortableColumnItem.propTypes = {
  column: PropTypes.shape({
    field: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
  isVisible: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
}

export default SortableColumnItem
